module.exports = __webpack_public_path__ + "89c95acc.png";